import { Config } from 'final-form';
import { HotelForm as Form } from 'hotel/HotelForm';

import { ClientTeamMemberOption } from 'hooks/useClientClientTeamMemberSelector';
import {
  RoomTypeQuantities,
  RoomConfigurations,
} from 'store/groupDetailsSlice';

import RoomTypeSection from './RoomTypeSection';

export type DoubleRoomSelection = {
  firstBed: ClientTeamMemberOption;
  secondBed: ClientTeamMemberOption;
};

export interface FormValues {
  suite: (ClientTeamMemberOption | undefined)[];
  double: (DoubleRoomSelection | undefined)[];
  single: (ClientTeamMemberOption | undefined)[];
}

type UpdateGroupRequestFormProps = {
  onSubmit: Config<FormValues>['onSubmit'];
  initialValues: FormValues;
  rooms: RoomTypeQuantities;
  roomConfigurations?: RoomConfigurations;
  formId?: string;
};
const UpdateGroupRequestForm = ({
  onSubmit,
  initialValues,
  rooms,
  roomConfigurations,
  formId,
}: UpdateGroupRequestFormProps) => {
  return (
    <Form<FormValues>
      onSubmit={onSubmit}
      initialValues={initialValues}
      render={({ handleSubmit, form }) => (
        <form onSubmit={handleSubmit} id={formId}>
          <div className="space-y-4">
            {/* Single Rooms */}
            <RoomTypeSection
              roomType="single"
              configurations={roomConfigurations?.single}
              quantity={rooms.single}
              form={form}
            />

            {/* Double Rooms */}
            <RoomTypeSection
              roomType="double"
              configurations={roomConfigurations?.double}
              quantity={rooms.double}
              form={form}
            />

            {/* Suite Rooms */}
            <RoomTypeSection
              roomType="suite"
              configurations={roomConfigurations?.suite}
              quantity={rooms.suite}
              form={form}
            />
          </div>
        </form>
      )}
    />
  );
};

export default UpdateGroupRequestForm;
